import { FC } from "react";
import Modal from "@/components/modal";

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  title?: string;
  /** When provided, a retry button is shown that invokes this callback. */
  onRetry?: () => void;
  retryLabel?: string;
}

/**
 * Reusable error modal for user-facing failure messages. Built on the shared
 * base Modal. Prefer triggering this via `useErrorModal()` (showError /
 * handleError) rather than wiring it up directly. Never use window.alert for
 * errors — see CLAUDE.md "Error Handling".
 */
const ErrorModal: FC<ErrorModalProps> = ({
  isOpen,
  onClose,
  message,
  title = "Something went wrong",
  onRetry,
  retryLabel = "Try again",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="max-w-md">
      <p className="text-gray-600 mb-6">{message}</p>
      <div className="flex justify-end gap-3">
        <button type="button" className="button outlined" onClick={onClose}>
          Close
        </button>
        {onRetry && (
          <button type="button" className="button primary" onClick={onRetry}>
            {retryLabel}
          </button>
        )}
      </div>
    </Modal>
  );
};

export default ErrorModal;
